"use client";

import { Button } from "@pamperedchef/design-system";
import { usePagination } from "react-instantsearch";

import * as styles from "./PlpPagination.module.scss";

export interface PlpPaginationProps {
	padding?: number;
}

export function PlpPagination({
	padding = 2
}: PlpPaginationProps): JSX.Element | null {
	const {
		pages,
		currentRefinement,
		nbPages,
		isFirstPage,
		isLastPage,
		refine
	} = usePagination({ padding });

	if (nbPages <= 1) return null;

	return (
		<nav
			className={styles["pagination"]}
			data-component="PlpPagination"
			aria-label="Pagination"
		>
			<Button
				kind="tertiary"
				size="sm"
				isDisabled={isFirstPage}
				onPress={() => refine(currentRefinement - 1)}
				aria-label="Previous page"
			>
				‹
			</Button>

			{pages.map((page) => (
				<Button
					key={page}
					kind="tertiary"
					size="sm"
					onPress={() => refine(page)}
					aria-label={`Page ${page + 1}`}
					aria-current={
						page === currentRefinement ? "page" : undefined
					}
				>
					{`${page + 1}`}
				</Button>
			))}

			<Button
				kind="tertiary"
				size="sm"
				isDisabled={isLastPage}
				onPress={() => refine(currentRefinement + 1)}
				aria-label="Next page"
			>
				›
			</Button>
		</nav>
	);
}
